import { FC, useState } from 'react'
import { useRecordContext, useRefresh, useNotify, useDataProvider } from 'react-admin'
import { Switch } from '@mui/material'
import { xxllncColor } from '../layout/theme/color'

interface ToolRecord {
  id: string
  enabled: boolean
}

interface ToolEnabledSwitchProps {
  resource: string
}

export const ToolEnabledSwitch: FC<ToolEnabledSwitchProps> = ({ resource }) => {
  const record = useRecordContext<ToolRecord>()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const [optimistic, setOptimistic] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(false)

  if (!record) return null

  const checked = optimistic !== null ? optimistic : record.enabled

  const handleToggle = () => {
    const newValue = !checked
    setOptimistic(newValue)
    setLoading(true)
    void dataProvider
      .update(resource, {
        id: record.id,
        data: { enabled: newValue },
        previousData: record,
      })
      .then(() => {
        setOptimistic(null)
        refresh()
      })
      .catch(() => {
        setOptimistic(null)
        notify('ra.notification.http_error', { type: 'error' })
      })
      .finally(() => setLoading(false))
  }

  return (
    <Switch
      checked={checked}
      onChange={handleToggle}
      onClick={(e) => e.stopPropagation()}
      disabled={loading}
      size="small"
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: xxllncColor.green100,
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: xxllncColor.opGreen60,
        },
      }}
    />
  )
}
